import Vue from 'vue'
import Router from 'vue-router'
import InicioPublico from '@/components/publico/inicio'
import unaCategoria from '@/components/publico/una_categoria'
import Contenido from '@/components/publico/contenido'
import login from '@/components/auth/login'
import Panel from '@/components/panel'
import authService from '../components/auth/auth.Service'

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/panel',
      name: 'panel',
      component: Panel,
      beforeEnter: requireAuth
    },
    {
      path: '/:cliente',
      name: 'inicio',
      component: InicioPublico
    },
    {
      path: '/:cliente/:categoria',
      name: 'unacategoria',
      component: unaCategoria
    },
    {
      path: '/:cliente/:categoria/:contenido',
      name: 'contenido',
      component: Contenido
    }
  ]
})

function requireAuth(to, from, next) {
  if (authService.isLogueado()) {
    next();
  } else {
    next({
      path: '/login'
    });
  }
}



// WEBPACK FOOTER //
// ./src/router/index.js